var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Copyright © "),_c('a',{attrs:{"href":"https://kyleahfrederic.com/"}},[_vm._v("Kyleah Frederic")]),_vm._v(" 2021")])}]

export { render, staticRenderFns }